import { type TimeEntry, useDeleteTimeEntry } from "@/hooks/use-time-entries";

interface DeleteEntryDialogProps {
  entry: TimeEntry;
  open: boolean;
  onClose: () => void;
}

export function DeleteEntryDialog({ entry, open, onClose }: DeleteEntryDialogProps) {
  const deleteEntry = useDeleteTimeEntry();
  const isPending = deleteEntry.isPending;

  if (!open) return null;

  async function handleConfirm() {
    try {
      await deleteEntry.mutateAsync(entry.id);
      onClose();
    } catch {
      // toast handled by mutation
    }
  }

  return (
    <div
      className="modal-backdrop"
      onClick={() => {
        if (!isPending) onClose();
      }}
    >
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal__header">
          <h2 className="modal__title">Delete this entry?</h2>
        </div>
        <div className="modal__body">
          <p style={{ margin: 0 }}>
            Are you sure you want to delete this draft entry? This cannot be undone.
          </p>
        </div>
        <div className="modal__footer">
          <button
            type="button"
            className="btn btn--secondary"
            onClick={onClose}
            disabled={isPending}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn--danger"
            onClick={handleConfirm}
            disabled={isPending}
          >
            {isPending ? "Deleting…" : "Delete entry"}
          </button>
        </div>
      </div>
    </div>
  );
}
